import styled from 'styled-components';
import { Wrapper as SectionWrapper, themeOptions } from '../Level3Section';
import { useEffect, useMemo, useState } from 'react';
import { SendIcon } from '../icons/send';
import { SyncManager } from 'db';
import { Field, useField } from 'react-final-form';
import { useFormVehicleId } from '../hooks/useFormVehicleId';
import { NotesSavedCheckmark } from 'components/VehicleCommon/icons/NotesSavedChekmark';
import { useTextareaEffects } from 'hooks/useTextareaEffects';
import { Checkbox, FormControlLabel, Radio, RadioGroup } from '@material-ui/core';

type Props = {
  theme: keyof typeof themeOptions;
};

const Header = styled.div`
  font-family: Roboto;
  font-weight: 600;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
  padding: 6px 8px 8px;
`;

const InputWrapper = styled.div<{ hasError: boolean }>`
  outline: ${props => (props.hasError ? '1px solid #AF2930' : '1px solid #999999')};
  border-radius: 8px;
  background: #fff;
  padding: 12px 8px;
  display: flex;
  align-items: center;
  margin: 8px;
`;

const StyledRadioGroup = styled(RadioGroup)`
  padding: 0 8px;
  & > label:last-child {
    margin-top: -8px;
  }
`;

const StyledRadio = styled(Radio)``;

const Input = styled.textarea`
  border: none;
  font-size: 12px;
  line-height: 16px;
  width: 80%;
  font-weight: 500;
  color: #000;
  padding: 0;
  font-family: Roboto;
`;

const IconWrapper = styled.div<{ withAutoMargin?: boolean }>`
  display: flex;
  margin-left: ${props => (props.withAutoMargin ? 'auto' : 0)};
`;

const StyledError = styled.span`
  font-size: 10px;
  color: #e93323;
  padding: 0 8px;
`;

const CheckboxRow = styled.div`
  display: flex;
  gap: 8px;
`;

export const DisclaimerCheckboxes = ({ theme }: Props) => {
  const { background } = themeOptions[theme];
  const id = useFormVehicleId();

  const { input } = useField(`is_guaranteed`);

  const handleAsIs = () => {
    if (!input.value) return;
    input.onChange(false);
    queueUpdate(false);
  };

  const handleGreenLight = () => {
    if (input.value) return;
    input.onChange(true);
    queueUpdate(true);
  };

  const queueUpdate = async value => {
    const syncManager = SyncManager.getInstance(id);
    syncManager.queueVehicleUpdate(['is_guaranteed', value]);
  };

  return (
    <SectionWrapper background={background} withBorder={theme === 'white'}>
      <Header>Disclaimer</Header>
      <StyledRadioGroup onChange={e => console.log('radio group change', e)} name="is_guaranteed">
        <FormControlLabel
          onChange={handleAsIs}
          control={<StyledRadio color="primary" checked={!input.value} />}
          label="Sold as is"
        />
        <FormControlLabel
          control={<StyledRadio color="primary" checked={input.value} />}
          label="Green Light. Motor, Tranny for 24hrs."
          onChange={handleGreenLight}
        />
      </StyledRadioGroup>
    </SectionWrapper>
  );
};
